import StatCard from 'components/atoms/StatCard';
import { GrowthMarginBridgeCardData } from './data/GrowthMarginBridgescardData';
import { useState } from 'react';
import GrowthBridgesChart from './GrowthBridgesChart';
import DecompositionChart from './DecompositionChart';

const GrowthMarginBridges = () => {
    const [selectedBar, setSelectedBar] = useState<string>('');

    return (
        <>
            <div
                className={`border border-borderLinePurpule bg-white p-4  rounded-lg            
            `}
            >
                <div className="mt-4 flex flex-col border border-[#0000000F] rounded-lg px-4 py-4 w-full">
                    <p className="font-semibold text-2xl">{'Growth / Margin Bridges'}</p>
                    <div className="flex flex-row gap-4">
                        {GrowthMarginBridgeCardData.map((cardData) => {
                            return (
                                <StatCard metricName={cardData?.metricName} absoluteValue={cardData?.absoluteValue} />
                            );
                        })}
                    </div>
                    <div className="mt-4 flex flex-col border border-[#0000000F] rounded-lg px-4 py-4 w-full">
                        <GrowthBridgesChart setSelectedBar={setSelectedBar} />
                    </div>

                    <div className="mt-4 flex flex-col border border-[#0000000F] rounded-lg px-4 py-4 w-full">
                        <DecompositionChart selectedBar={selectedBar} />
                    </div>
                </div>
            </div>
        </>
    );
};

export default GrowthMarginBridges;
